import { Box, Flex, Text, Badge } from "@chakra-ui/react";

export default function InformativeVerticalProgress({ steps = [] }) {
  if (!steps.length) {
    return (
      <Text fontSize="sm" color="gray.400">
        Belum ada aktivitas
      </Text>
    );
  }

  return (
    <Box>
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;

        return (
          <Flex key={index} align="flex-start">
            {/* LEFT DOT + LINE */}
            <Flex direction="column" align="center" mr={4}>
              <Box
                w="14px"
                h="14px"
                borderRadius="full"
                bg="green.500"
                mt="6px"
              />
              {!isLast && (
                <Box
                  w="2px"
                  h="60px"
                  bg="gray.300"
                  mt="2px"
                />
              )}
            </Flex>

            {/* CONTENT */}
            <Box pb={6}>
              <Badge colorScheme="green" mb={1}>
                {step.status.toUpperCase()}
              </Badge>

              <Text fontSize="sm" fontWeight="bold">
                {step.label}
              </Text>

              <Text fontSize="sm" color="gray.600">
                Oleh: {step.user}
              </Text>

              <Text fontSize="xs" color="gray.400">
                {step.time}
              </Text>
            </Box>
          </Flex>
        );
      })}
    </Box>
  );
}
